import { render, staticRenderFns } from "./Stretch.vue?vue&type=template&id=3412e418&scoped=true&"
import script from "./Stretch.vue?vue&type=script&lang=js&"
export * from "./Stretch.vue?vue&type=script&lang=js&"
import style0 from "./Stretch.vue?vue&type=style&index=0&id=3412e418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412e418",
  null
  
)

export default component.exports